<div class="discover-main-container col-xs-12 col-md-8">
  <div class="discover-section">
    <div class="banner">
      <h3 class="mode-header">Welcome to {{ appName }}!</h3>
      <p>Here are some tips and tricks for getting started. We're so glad you're here.</p>
    </div>
  </div>
  <div class="discover-section clearfix" *ngFor="let section of sections">
    <div class="hero-image col-xs-12 col-md-3">
      <capra-icon class="hero-icon" icon="{{ section.icon }}"></capra-icon>
    </div>
    <div class="section-details col-xs-12 col-md-9">
      <h3 class="mode-header">{{ section.header }}</h3>
      <p>{{ section.body }}</p>
      <div class="section-buttons">
        <capra-button
          *ngFor="let button of section.buttons"
          text="{{ button.text }}"
          (click)="button.clickAction($event)"
          class="{{ button.class }}"
          attr.data-test="{{ button.testAttribute }}"
        >
        </capra-button>
      </div>
    </div>
  </div>
</div>
